import {React, useState }from 'react'
import { Link } from 'react-router-dom'

function SubMenu() {
    
 const [isMenuOpen, setIsMenuOpen] = useState(false);
 const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
 const [isSubBlogOpen, setIsSubBlogOpen] = useState(false);
 const [isSubBloggridOpen, setIsSubBloggridOpen] = useState(false);
 const [isSubPagesOpen, setIsSubPagesOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleSubmenu = () => {
    setIsSubmenuOpen(!isSubmenuOpen);
  };
  const toggleSubBlog = () => {
    setIsSubBlogOpen(!isSubBlogOpen);
  };
  const toggleSubBloggrid = () => {
    setIsSubBloggridOpen(!isSubBloggridOpen);
  };
  const toggleSubPages = () => {
    setIsSubPagesOpen(!isSubPagesOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsSubmenuOpen(false);
  };


  return (
    <div>
    {isMenuOpen && (
        <nav >
                <ul className= {`navigation main-menu ${isMenuOpen ? 'open' : ''}`}>
                    <li className="menu-item menu-item-has-children">
                        <Link to="#" onClick={toggleSubmenu} className="active">Home</Link>
                        {isSubmenuOpen && (
                        <ul className="sub-menu">
                            <li className="menu-item">
                                <Link to="" onClick={closeMenu}>Homepage v1</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/home-v2" onClick={closeMenu}>Homepage v2</Link>
                            </li>
                        </ul>
                        )}
                    </li>
                    <li className="menu-item">
                        <Link to="/about" onClick={closeMenu}>About</Link>
                    </li>
                    <li className="menu-item menu-item-has-children">
                        <Link to="#" onClick={toggleSubBlog}>Blog</Link>
                        {isSubBlogOpen && (
                        <ul className="sub-menu">
                            <li className="menu-item menu-item-has-children">
                                <Link to="#" onClick={toggleSubBloggrid}>Blog Grid</Link>
                                {isSubBloggridOpen && (
                                <ul className="sub-menu">
                                    <li className="menu-item">
                                        <Link to="/blog-grid" onClick={closeMenu}>Full Width</Link>
                                    </li>
                                    <li className="menu-item">
                                        <Link to="/blog-grid-left" onClick={closeMenu}>Left Sidebar</Link>
                                    </li>
                                    <li className="menu-item">
                                        <Link to="/blog-grid-right" onClick={closeMenu}>Right Sidebar</Link>
                                    </li>
                                </ul>
                                )}
                            </li>
                            <li className="menu-item">
                                <Link to="/blog-details" onClick={closeMenu}>Blog Details</Link>
                            </li>
                        </ul>
                        )}
                    </li>
                    <li className="menu-item menu-item-has-children">
                        <Link to="#" onClick={toggleSubPages}>Pages</Link>
                        {isSubPagesOpen && (
                        <ul className="sub-menu">
                            <li className="menu-item">
                                <Link to="/services" onClick={closeMenu}>Services</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/team" onClick={closeMenu}>Team</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/trainer" onClick={closeMenu}>Trainer</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/schedule" onClick={closeMenu}>Schedule</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/pricing" onClick={closeMenu}>Pricing</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/program" onClick={closeMenu}>Program</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/gallery" onClick={closeMenu}>Gallery</Link>
                            </li>
                        </ul>
                        )}
                    </li>
                    <li className="menu-item">
                        <Link to="/contact" onClick={closeMenu}>Contact</Link>
                    </li>
                </ul>
            </nav>
    )}
   
      <button className={`hamburger hamburger-menu hamburger_btn ${isMenuOpen ? 'open' : ''}`}  onClick={toggleMenu}>
          <div className="hamburger-menu hamburger_btn">
            <span></span>
            <span></span>
            <span></span>
          </div>
      </button>
    </div>
  )
}

export default SubMenu